import { SkeletonLoader } from "@whoosh/design-system/src/components/display";
import {
  Box,
  HStack,
  VStack,
} from "@whoosh/design-system/src/components/primitive";

const SKELETON_ROW_COUNT = 14;

const rows = Array.from({ length: SKELETON_ROW_COUNT });

export const TimeSlotSkeletonRow = () => {
  return (
    <Box flex={1} mt={4} testID="time-slot-list-skeleton">
      <VStack gap={2}>
        {rows.map((_, index) => (
          <Box
            key={index}
            px={{ base: 4, agendaSplit: 0 }}
            maxWidth={{ base: "100%", md: 720 }}
            width="100%"
            style={{ marginHorizontal: "auto" }}
          >
            <Box
              backgroundColor="surface-primary"
              borderRadius="4"
              p={4}
              borderColor="grayscale-200"
              borderWidth={1}
            >
              <HStack alignItems="center" justifyContent="space-between">
                <VStack gap={2} flex={1}>
                  <SkeletonLoader width={96} height={18} borderRadius="2" />
                  <SkeletonLoader width="70%" height={14} borderRadius="2" />
                </VStack>
                <SkeletonLoader width={72} height={32} borderRadius="6" />
              </HStack>
            </Box>
          </Box>
        ))}
      </VStack>
    </Box>
  );
};
